
import io from 'socket.io-client';

export const initializeSocket = (userId) => {
  const socket = io(process.env.REACT_APP_SOCKET_URL, {
    transports: ['websocket', 'polling'],
    query: {
      'token': localStorage.getItem('token'),
      userId:userId
    }
  });

  socket.on('connect', (err) => {
    console.log('connected to server:',err);
  });


  socket.on('connect_error', (err) => {
    console.error('Connection Error:', err.message);
  });

  return socket;
};

export const emitEvent = (socket, eventName, payload, callback) => {
  socket.emit(eventName, payload, callback);
};

export const listenEvent = (socket, eventName, callback) => {
  socket.on(eventName, callback);
};

export const disconnectSocket = (socket) => {
  if (socket && socket?.connected) {
    socket.disconnect();
    console.log('🔌 Socket disconnected');
  }
}
